import React, { useState } from 'react';
import { ChevronRightIcon, ChevronLeftIcon } from 'lucide-react';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { useLanguage } from '../hooks/useLanguage';
export function SecuritySection() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const {
    ref,
    isVisible
  } = useScrollReveal();
  const {
    t,
    direction
  } = useLanguage();
  const slides = [{
    title: t('security.security.title'),
    subtitle: t('security.security.subtitle'),
    description: t('security.security.description'),
    image: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?q=80&w=2070&auto=format&fit=crop'
  }, {
    title: t('security.fraud.title'),
    subtitle: t('security.fraud.subtitle'),
    description: t('security.fraud.description'),
    image: 'https://images.unsplash.com/photo-1563013544-824ae1b704d3?q=80&w=2070&auto=format&fit=crop'
  }, {
    title: t('security.data.title'),
    subtitle: t('security.data.subtitle'),
    description: t('security.data.description'),
    image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?q=80&w=2070&auto=format&fit=crop'
  }];
  const nextSlide = () => {
    setCurrentSlide(prev => (prev + 1) % slides.length);
  };
  const slide = slides[currentSlide];
  const ArrowIcon = direction === 'rtl' ? ChevronLeftIcon : ChevronRightIcon;
  return <section className="py-32 md:py-44 px-6 md:px-12 bg-white relative z-10" dir={direction} data-id="element-362">
      {/* Background decoration bottom-left - overlaps into PartnersSection */}
      <img src="https://cdn.magicpatterns.com/uploads/i7gpwPgxGpJxXDHwRZ8TSv/7.svg" alt="" className="absolute bottom-0 left-0 w-[600px] h-auto pointer-events-none" style={{
      zIndex: 20,
      transform: 'translateY(50%)'
    }} data-id="element-363" />

      <div ref={ref} className="max-w-7xl mx-auto relative" style={{
      zIndex: 30
    }} data-id="element-364">
        {/* Connected card: text + image */}
        <div className={`flex flex-col md:flex-row reveal-hidden ${isVisible ? 'animate-scale-in' : ''}`} data-id="element-365">
          {/* Text Content - Left Side with border */}
          <div className={`md:w-[40%] p-8 md:p-10 flex flex-col justify-center bg-white ${direction === 'rtl' ? 'rounded-r-[20px]' : 'rounded-l-[20px]'}`} style={{
          border: '1px solid #DDDDDD'
        }} data-id="element-366">
            <h2 className="text-2xl md:text-3xl font-bold text-[#061d76] mb-4" data-id="element-367">
              {slide.title}
              <br data-id="element-368" />
              {slide.subtitle}
            </h2>
            <p className="text-[#061D76] leading-relaxed text-sm" data-id="element-369">
              {slide.description}
            </p>
          </div>

          {/* Image - Right Side */}
          <div className="md:w-[60%] relative" data-id="element-370">
            <img src={slide.image} alt={`${slide.title} ${slide.subtitle}`} className={`w-full h-[250px] md:h-full object-cover ${direction === 'rtl' ? 'rounded-l-[20px]' : 'rounded-r-[20px]'}`} data-id="element-371" />

            {/* Navigation Arrow */}
            <button onClick={nextSlide} className={`absolute ${direction === 'rtl' ? 'left-4' : 'right-4'} top-1/2 -translate-y-1/2 w-10 h-10 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-gray-50 transition-colors`} aria-label="Next slide" data-id="element-372">
              <ArrowIcon className="w-5 h-5 text-[#061d76]" data-id="element-373" />
            </button>
          </div>
        </div>
      </div>
    </section>;
}